import React from 'react';
import { useDispatch } from 'react-redux';
import { changeProductServiceTab } from '../../../Actions/Configurator.action';
import plusIcon from '../../../../images/plusIcon.svg';

const ModeSelection = ({ tab, icon, title, text }) => {
  const dispatch = useDispatch();

  return (
    <a onClick={() => dispatch(changeProductServiceTab(tab))} className='configuratorServiceTab'>
      <div className='upperServiceTabPart'>
        <div className='upperServiceTabPartLeft'>
          <img src={icon} className='productPaneIconStyling' />
          <h6 className='serviceTitle'>{title}</h6>
        </div>
        <img src={plusIcon} className='configurationServiceTabPlusIcon' />
      </div>
      <div className='lowerServiceTabPart'>
        <p className='serviceTabparagraphText'>{text}</p>
      </div>
    </a>
  );
};

export default ModeSelection;
